const Styles = {
    'GeoRadiusFilter': 'GeoRadiusFilter_GeoRadiusFilter--ecbbc0fe',
    'AutoCompleteContainer': 'GeoRadiusFilter_AutoCompleteContainer--7d09c02d'
};

export default Styles;